<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('小组ID')" prop="groupId">
        <a-input-number v-model="form.groupId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'小组ID'" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户ID')" prop="userId">
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item :label="$t('成员角色')" prop="memberRole">
        <a-select v-model="form.memberRole" :placeholder="$t('请选择')+'成员角色'" style="width: 100%">
          <a-select-option :value="10">{{ $t('普通成员') }}</a-select-option>
          <a-select-option :value="20">{{ $t('管理员') }}</a-select-option>
          <a-select-option :value="30">{{ $t('组长') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('成员状态')" prop="memberStatus">
        <a-select v-model="form.memberStatus" :placeholder="$t('请选择')+'成员状态'" style="width: 100%">
          <a-select-option :value="10">{{ $t('正常') }}</a-select-option>
          <a-select-option :value="20">{{ $t('待审核') }}</a-select-option>
          <a-select-option :value="30">{{ $t('已拒绝') }}</a-select-option>
          <a-select-option :value="40">{{ $t('已移出') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('加入时间')" prop="joinTime">
        <a-date-picker
          style="width: 100%"
          v-model="form.joinTime"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupMember, addCommunityGroupMember, updateCommunityGroupMember } from '@/api/community/communityGroup/communityGroupMember'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        groupId: null,
        userId: null,
        memberRole: null,
        memberStatus: 10,
        joinTime: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          groupId: [{ required: true, message: '小组ID' + this.$t('不能为空'), trigger: 'blur' }],
          userId: [{ required: true, message: '用户ID' + this.$t('不能为空'), trigger: 'blur' }],
          memberRole: [{ required: true, message: '成员角色' + this.$t('不能为空'), trigger: 'blur' }],
          memberStatus: [{ required: true, message: '成员状态' + this.$t('不能为空'), trigger: 'blur' }],
          joinTime: [{ required: true, message: '加入时间' + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        groupId: null,
        userId: null,
        memberRole: null,
        memberStatus: 10,
        joinTime: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupMember({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupMember(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupMember(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
